import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

const tooltip = {
  fontFamily: 'var(--fontFamilyBody) !important',
  fontSize: '14px !important',
  padding: '3px 8px !important',
  borderRadius: '4px !important',
  display: 'flex !important',
  alignItems: 'center !important',
  justifyContent: 'space-between !important',
  zIndex: '1 !important',
  transition: 'transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important',
  animation: '$bounce 0.5s ease-out !important',
};

const styles = {
  light: {
    ...tooltip,
    backgroundColor: '#FFFFFF !important',
    color: '#000000 !important',
    border: '1px solid #dcdcdc !important',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1) !important',
    '& .MuiTooltip-arrow': {
      color: '#FFFFFF !important',
      '&::before': {
        border: '1px solid #dcdcdc !important',
      },
    },
  },
  dark: {
    ...tooltip,
    backgroundColor: 'var(--searchButtonColorHex) !important',
    color: 'var(--searchBtnTextColorHex) !important',
    border: '1px solid var(--searchButtonColorHex) !important',
    '& .MuiTooltip-arrow': {
      color: 'var(--searchButtonColorHex) !important',
    },
  },
  default: {
    ...tooltip,
    backgroundColor: 'white !important',
    color: 'black !important',
    borderStyle: 'solid !important',
    borderWidth: '2px !important',
    fontSize: '12px !important',
  },
  '@keyframes bounce': {
    '0%, 100%': {
      transform: 'translateY(0) !important',
    },
    '50%': {
      transform: 'translateY(-10px) !important',
    },
  },
};

const ToolTip = ({
  title,
  open,
  onClose,
  children,
  classes,
  variant,
  showCloseIcon,
  disableHoverListener,
  zIndex,
  disablePortal,
  placement,
}) => {
  const handleClose = (event) => {
    event.stopPropagation();
    if (onClose) {
      onClose();
    }
  };

  const tooltipContent = (
    <>
      {title}
      {showCloseIcon && (
        <IconButton size="small" onClick={handleClose}>
          <CloseIcon
            fontSize="text-sm"
            style={{ color: variant === 'dark' ? '#FFFFFF' : '#000000' }}
          />
        </IconButton>
      )}
    </>
  );

  let offsetDistance = 14;
  if (placement === 'bottom') offsetDistance = -7;
  else if (placement === 'top') offsetDistance = -7;

  return (
    <Tooltip
      classes={{
        tooltip: classes[variant],
        arrow: classes[variant] && classes[variant]['& .MuiTooltip-arrow'],
      }}
      title={tooltipContent}
      open={disableHoverListener ? open : undefined}
      placement={placement}
      disableHoverListener={disableHoverListener}
      arrow
      PopperProps={{
        disablePortal,
        style: { zIndex },
        modifiers: [
          {
            name: 'offset',
            options: { offset: [0, offsetDistance] },
          },
        ],
      }}
    >
      {children}
    </Tooltip>
  );
};

ToolTip.propTypes = {
  title: PropTypes.node.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  classes: PropTypes.object || {},
  variant: PropTypes.oneOf(['light', 'dark', 'default']),
  showCloseIcon: PropTypes.bool,
  disableHoverListener: PropTypes.bool,
  zIndex: PropTypes.number,
  disablePortal: PropTypes.bool,
  placement: PropTypes.string,
};

ToolTip.defaultProps = {
  classes: {},
  variant: 'dark',
  showCloseIcon: true,
  disableHoverListener: true,
  onClose: undefined,
  open: undefined,
  disablePortal: true,
  zIndex: 1500, // 1500 is default value of zIndex for MUI Tooltip.
  placement: 'top',
};

export default withStyles(styles)(ToolTip);
